namespace RioERP.Administration {
    export namespace PermissionKeys {
        export const Security = "Administration:Security";
        export const Translation = "Administration:Translation";
        export const Publisher = "Administration:Publisher";
        export const Franchisee = "Users:Franchisee";
        export const Teachers = "Users:Teachers";
        export const Manager = "Users:Manager";
        export const SalesExecutive = "Users:SalesExecutive";
        export const TechSupport = "Users:TechSupport";
    }
}
